import './App.css';
import AppNavigator from './pages/AppNavigator';
import { ToastProvider } from './utils/Toast';

function App() {
  return (
    <>
      <ToastProvider />
      <AppNavigator />
    </>
  );
}

export default App;